import * as React from "react";
import { MediaQuery } from "react-responsive";
import { CollapseToggle } from "../../collapse-toggle/collapse-toggle.mjs";
import { ThemeContext } from "../../helpers/theme-provider/theme-provider.mjs";
const _TableCollapseTrigger = class _TableCollapseTrigger extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.onClick) {
        this.props.onClick(event);
      }
      if (this.props.onToggle) {
        this.props.onToggle(this.props.url.replace("#", ""));
      }
    };
    this.state = {
      isMounted: false
    };
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }
  get text() {
    if (this.props.isActive && this.props.textLess) {
      return this.props.textLess;
    }
    return this.props.text;
  }
  get breakpoint() {
    if (!this.props.iconBreak) {
      return "0px";
    }
    return this.context.media.width[this.props.iconBreak].min;
  }
  getIcon(iconMore, iconLess) {
    if (this.props.isActive && iconLess) {
      return iconLess;
    }
    return iconMore;
  }
  getIcons(shouldSwitch, iconMoreLeft, iconLessLeft, iconMoreRight, iconLessRight) {
    let iconLeft = iconMoreLeft && this.getIcon(iconMoreLeft, iconLessLeft);
    let iconRight = iconMoreRight && this.getIcon(iconMoreRight, iconLessRight);
    if (shouldSwitch) {
      iconLeft = iconMoreRight && this.getIcon(iconMoreRight, iconLessRight);
      iconRight = iconMoreLeft && this.getIcon(iconMoreLeft, iconLessLeft);
    }
    return {
      iconLeft,
      iconRight
    };
  }
  renderCollapseToggle(matches) {
    const { iconBreak, iconLeft, iconLessLeft, iconRight, iconLessRight, url, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement(
      CollapseToggle,
      {
        ...rest,
        element: "button",
        text: this.text,
        "aria-expanded": this.props.isActive,
        iconLeft: this.props.iconLeft ? this.getIcon(this.props.iconLeft, this.props.iconLessLeft) : void 0,
        iconRight: this.props.iconRight ? this.getIcon(this.props.iconRight, this.props.iconLessRight) : void 0,
        onClick: this.onClick,
        ...this.getIcons(matches && !!iconBreak, iconLeft, iconLessLeft, iconRight, iconLessRight)
      }
    );
  }
  render() {
    return this.state.isMounted ? /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: this.breakpoint }, (matches) => this.renderCollapseToggle(!matches)) : this.renderCollapseToggle(false);
  }
};
_TableCollapseTrigger.contextType = ThemeContext;
let TableCollapseTrigger = _TableCollapseTrigger;
export {
  TableCollapseTrigger
};
